import Dashboard from "../../pages/find-a-job/Dashboard";
import JobsList from "../../pages/find-a-job/JobsList";
import Learning from "../../pages/find-a-job/Learning";
import Offer from "../../pages/find-a-job/Offer";
import Profile from "../../pages/find-a-job/Profile";
import EditProfile from "../../pages/find-a-job/EditProfile";
import Settings from "../../pages/find-a-job/Settings";
import Subscription from "../../components/Modals/find-a-job/Subscription";
import MyJob from "../../pages/find-a-job/MyJob";
import MyCourses from "../../pages/find-a-job/MyCourses";
import MyProjects from "../../pages/find-a-job/MyProjects";
import Inbox from "../../pages/find-a-job/Inbox";
import Ebook from "../../pages/find-a-job/Ebook";
import Workshop from "../../pages/find-a-job/Workshop";
import Coaching from "../../pages/find-a-job/Coaching";
import Growth from "../../pages/find-a-job/Growth";

export const findAJobPaths = {
  Dashboard: "/freelance/dashboard",
  Profile: "/freelance/profile",
  EditProfile: "/freelance/profile/edit",
  Offer: "/freelance/offers",
  Settings: "/freelance/settings",
  Learning: "/freelance/learning",
  Subscription: "/freelance/subscription",
  MyJob: "/freelance/my-job",
  MyCourses: "/freelance/my-courses",
  MyProjects: "/freelance/my-projects",
  Inbox: "/freelance/inbox",
  Ebook: "/freelance/Ebook",
  Workshop: "/freelance/workshop",
  Coaching: "/freelance/coaching",
  Growth: "/freelance/growth",
};

export const AllFindAJobRoutes = [
  {
    name: "Dashboard",
    path: findAJobPaths?.Dashboard,
    element: <Dashboard />,
    isPrivate: false,
  },
  {
    name: "Profile",
    path: findAJobPaths?.Profile,
    element: <Profile />,
    isPrivate: false,
  },
  {
    name: "Edit Profile",
    path: findAJobPaths?.EditProfile,
    element: <EditProfile />,
    isPrivate: false,
  },
  {
    name: "Offer",
    path: findAJobPaths?.Offer,
    element: <Offer />,
    isPrivate: false,
  },
  {
    name: "Settings",
    path: findAJobPaths?.Settings,
    element: <Settings />,
    isPrivate: false,
  },
  {
    name: "Learning",
    path: findAJobPaths?.Learning,
    element: <Learning />,
    isPrivate: false,
  },
  {
    name: "Subscription",
    path: findAJobPaths?.Subscription,
    element: <Subscription />,
    isPrivate: false,
  },
  {
    name: "MyJob",
    path: findAJobPaths?.MyJob,
    element: <MyJob />,
    isPrivate: false,
  },
  {
    name: "MyCourses",
    path: findAJobPaths?.MyCourses,
    element: <MyCourses />,
    isPrivate: false,
  },
  {
    name: "MyProjects",
    path: findAJobPaths?.MyProjects,
    element: <MyProjects />,
    isPrivate: false,
  },
  {
    name: "Inbox",
    path: findAJobPaths?.Inbox,
    element: <Inbox />,
    isPrivate: false,
  },
  {
    name: "Ebook",
    path: findAJobPaths?.Ebook,
    element: <Ebook />,
    isPrivate: false,
  },
  {
    name: "Workshop",
    path: findAJobPaths?.Workshop,
    element: <Workshop />,
    isPrivate: false,
  },
  {
    name: "Coaching",
    path: findAJobPaths?.Coaching,
    element: <Coaching />,
    isPrivate: false,
  },
  {
    name: "Growth",
    path: findAJobPaths?.Growth,
    element: <Growth />,
    isPrivate: false,
  },
];
